import { Component } from '@angular/core';
import { IconComponent } from '../../shared';
import { PAIN_POINTS } from '../../content/home.content';

@Component({
  selector: 'app-pain-points',
  imports: [IconComponent],
  templateUrl: './pain-points.component.html'
})
export class PainPointsComponent {
  readonly content = PAIN_POINTS;
}
